import { useState } from 'react'
import InputValidate from '../../components/InputValidate'
import logo from '../../images/LOGO_FIT.png'
import { FormLogin } from '../../Utils/DataType'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Button } from '@mui/material';
import UtilFunctions from '../../Utils/UtilFucntion';
import AxiosClient from '../../api/AxiosClient';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Register from './register';
import ForgotPassword from './ForgotPassword';
export default function Login() {
    const [dataForm, setDataForm] = useState<FormLogin>({ email: '', password: '' });
    const [isLogin, setIsLogin] = useState<boolean>(true);
    const [isPassword, setIsPassword] = useState<boolean>(false);

    function onChangeData(field: string, value: string): void {
        setDataForm({ ...dataForm, [field]: value });
    }

    function onSubmitForm(): void {
        AxiosClient.post('/login', { email: dataForm.email, password: dataForm.password }).then((data) => {
            let token = data.data.authorization.token;
            localStorage.setItem('sgu_student_token', token);
            UtilFunctions.showToastSuccess('Đăng nhập thành công!')
            setTimeout(() => {
                window.location.href = '/'
            }, 1000);
        }).catch((e) => {
            console.log(e);
            UtilFunctions.showToastError(`Lỗi: ${e.response.data.message}`)
        })
    }
    return (
        <div className="login-page">
            <ToastContainer />
            {isLogin && !isPassword &&
                (<div className="login-main">
                    <div className="login-logo">
                        <div className="login-logo--image">
                            <img src={logo} alt="Logo" />
                        </div>
                    </div>
                    <div className="login-title">
                        <div className="login-title--title">Đăng nhập</div>
                        <div className="login-title--description">Sử dụng tài khoản được cấp để đăng nhập vào hệ thống</div>
                    </div>
                    <div className="login-form">
                        <InputValidate label={'Email:'} name={'email'} onChangeData={onChangeData} value={dataForm.email} isValid={UtilFunctions.isValidEmail(dataForm.email)} alert={'Vui lòng nhập email hợp lệ'} disabled={false} placeholder='Email...' type='text'></InputValidate>
                        <InputValidate label={'Mật khẩu:'} name={'password'} onChangeData={onChangeData} value={dataForm.password} isValid={UtilFunctions.isValidPassword(dataForm.password)} alert={'Mật khẩu phải dài hơn 8 ký tự'} disabled={false} placeholder='Password...' type='password'></InputValidate>
                    </div>
                    <div className="login-option">
                        <FormControlLabel className="remember-account" sx={{ color: '#616161' }} control={<Checkbox defaultChecked size='small' />} label="Nhớ tài khoản" />
                        <div className="forget" onClick={() => {
                            setIsLogin(false);
                            setIsPassword(true);
                        }}>Quên mật khẩu?</div>
                    </div>
                    <div className="login-action">
                        <Button variant='contained' sx={{
                            height: '2.5rem', '&:disabled': {
                                cursor: 'not-allowed',
                            }
                        }}
                            onClick={onSubmitForm}
                            fullWidth disabled={!UtilFunctions.isValidEmail(dataForm.email) || !UtilFunctions.isValidPassword(dataForm.password)} >Đăng nhập</Button>
                    </div>
                    <div className="login-bonus">
                        Nếu bạn chưa có tài khoản, vui lòng <span onClick={() => setIsLogin(false)}>đăng ký</span>
                    </div>
                </div>)}
            {!isLogin && !isPassword && <Register setIsLogin={setIsLogin} />}
            {!isLogin && isPassword && <ForgotPassword />}
        </div>
    )
}